document.addEventListener('DOMContentLoaded', () => {

  const dialog = document.getElementById('email-dialog');

  if (!dialog) return;

  /*
    OPEN BUTTONS
    Any element with:
    data-open-email-dialog
  */
  // document.querySelectorAll('.button-secondary--Abms5UjVrUXZyL2wyb__button_44trmJ')
  //   .forEach(button => {

  //    button.setAttribute('aria-disabled', false);
  //    button.href = "#contact_form";
  //   //  button.addEventListener('click', (e) => {
  //   //     console.log(e, 'e')
  //   //     e.preventDefault();
  //   //     dialog.showModal();
  //   //   });

  //   });

  /*
    CLOSE BUTTONS
  */
  document.querySelectorAll('[data-close-dialog]')
    .forEach(button => {

      button.addEventListener('click', () => {
        dialog.close();
      });

    });

});